import {
  Component,

} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { PaymentsStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/payments-standard-quote/payments-standard-quote-wrapper.component';

@Component({
  selector: 'app-payments-standard-quote-mobile',
  templateUrl: './payments-standard-quote-mobile.component.html',
  styleUrls: ['./payments-standard-quote-mobile.component.scss'],
})
export class PaymentsStandardQuoteMobileComponent extends PaymentsStandardQuoteWrapperComponent {
  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menuService, notification);
  }
}
